const SUCCESS = 'success'
const INITIATED = 'initiated'
const PENDING = 'pending'
const FAILURE = 'failure'
const USER_CANCELLED = 'userCancelled'
const DROPPED = 'dropped'
const BOUNCED = 'bounced'
const PRE_INITIATED = 'preinitiated'

export {
    BOUNCED,
    DROPPED,
    FAILURE,
    INITIATED,
    PENDING,
    PRE_INITIATED,
    SUCCESS,
    USER_CANCELLED,
}
